module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c15700459e57153ea5c0c6929a9e57dd.png";